<template>
  <div class="creams">
    <div class="creams-actions row justify-content-end">
      <router-link to="/creams/new" class="btn btn-primary">
        Sorte hinzufügen
      </router-link>
    </div>
    <div class="creams-alert" v-if="alert.message">
      <div class="alert alert-dismissable fade show"
        :class="'alert-' + alert.type">
        <button type="button" class="close" data-dismiss="alert">
          <span>&times;</span>
        </button>
        {{ alert.message }}
      </div>
    </div>
    <table class="creams-index table">
      <thead>
        <th>Sorte</th>
        <th></th>
      </thead>
      <tbody>
        <tr v-for="cream in creams">
          <td class="name">
            <router-link :to="'/creams/edit/' + cream.id">
              {{ cream.name }}
            </router-link>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import flash from '../../../services/flash'

export default {
  name: 'creams',
  data () {
    return {
      creams: [],
      alert: {}
    }
  },

  created () {
    this.alert = flash.pop()
    this.$http.get('/api/creams')
      .then((res) => {
        this.creams = res.body.creams
      })
      .catch(reason => console.log(reason))
  }
}
</script>

<style scoped lang="scss">
  @import '../../../assets/styles/variables';

  .creams-actions {
    margin: $spacer-y 0;
  }

  .creams-index {
    margin: $spacer-y 0;
  }
</style>



// WEBPACK FOOTER //
// index.vue?9d5456dc